import appModalConstants from '../actiontypes/appModal';



function loadingOn(text) {
  return { type: appModalConstants.LOADER_ON, loadingText: text };
}

function loadingOff() {
  return { type: appModalConstants.LOADER_OFF };
}

function openErrorModal(message) {
  return { type: appModalConstants.ERROR_MODAL_OPENED, message};
}

function closeErrorModal() {
  return { type: appModalConstants.ERROR_MODAL_CLOSED};
}

function redirectErrorModal(redirect) {
  return { type: appModalConstants.SET_PATH_REDIRECT, redirect};
}

const appModalActions = {
  loadingOn,
  loadingOff,
  openErrorModal,
  closeErrorModal,
  redirectErrorModal
};

export default appModalActions;
